import community from './community.js';
import scoreboard from './scoreboard.js';
import contentDetails from './content-details.js';
import proofing from './proofing.js';
import shared from './shared.js';
import users from './users.js';
import errors from './errors.js';
import workflowFeedback from './workflow-feedback.js';
import folders from './folders.js';
import operationsPortal from './operations-portal.js';
import recording from './recording.js';
import groups from './groups.js';
import media from './media.js';
import companies from './companies.js';
import optionsTraining from './options-training.js';
import request from './request.js';
import uploader from './uploader.js';
import organization from './organization.js';
import room from './room.js';
import writeup from './writeup.js';
import leads from './leads.js';
import simpleLogin from './simple-login.js';
import microlearning from './microlearning.js';
import editAssignments from './edit-assignments.js';
import covert from './covert.js';
import editingContinuity from './editing-continuity.js';

export default {
    scoreboard,
    editingContinuity,
    search: {
        selectLoaded: 'Select loaded items ({count})',
        selectionScope: '{selected} selected across filters. Only loaded, selectable items are included; scroll to load more, then select again.',
    },
    community,
    contentDetails,
    proofing,
    shared,
    users,
    errors,
    workflowFeedback,
    folders,
    operationsPortal,
    recording,
    groups,
    media,
    companies,
    optionsTraining,
    request,
    uploader,
    organization,
    room,
    writeup,
    leads,
    simpleLogin,
    microlearning,
    editAssignments,
    covert,
}
